import * as Types from '../../../graphql.generated';

import { UserWithTrackedPropertiesFragment } from '../../AuthModal/queries/userWithTrackedProperties.generated';
import { UserWithTrackedPropertiesFragmentDoc } from '../../AuthModal/queries/userWithTrackedProperties.generated';
export type SocialSignInGoogleOneTapMutationVariables = Types.Exact<{
    accessToken: Types.Scalars['String'];
}>;

export type SocialSignInGoogleOneTapMutation = { __typename?: 'Mutation' } & {
    socialSignInGoogleOneTapV2?: Types.Maybe<
        | ({ __typename: 'DefaultAuthSuccess' } & Pick<
              Types.DefaultAuthSuccess,
              'authType'
          > & {
                  user: {
                      __typename?: 'User';
                  } & UserWithTrackedPropertiesFragment;
              })
        | ({ __typename: 'AuthError' } & Pick<Types.AuthError, 'errorCode'>)
    >;
};

export const SocialSignInGoogleOneTapDocument = `
    mutation socialSignInGoogleOneTap($accessToken: String!) {
  socialSignInGoogleOneTapV2(accessToken: $accessToken) {
    __typename
    ... on DefaultAuthSuccess {
      authType
      user {
        ...UserWithTrackedProperties
      }
    }
    ... on AuthError {
      errorCode
    }
  }
}
    ${UserWithTrackedPropertiesFragmentDoc}`;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {
        socialSignInGoogleOneTap(
            variables: SocialSignInGoogleOneTapMutationVariables,
            options?: C
        ): Promise<SocialSignInGoogleOneTapMutation> {
            return requester<
                SocialSignInGoogleOneTapMutation,
                SocialSignInGoogleOneTapMutationVariables
            >(SocialSignInGoogleOneTapDocument, variables, options);
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
